export default __webpack_public_path__ + "static/media/basiercircle-regular-webfont.1fe958d7.woff";